function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import PhoneInputComponent from "react-phone-input-2";
import { componentStyles } from "./phone-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { phoneInputStyles } from "./phone-input-component.scss";
class PhoneInput extends PureComponent {
    render() {
        const { inputData, errorState, value, cloudfrontViewerCountry, id } = this.props;
        const { inputName, isRequired } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const defaultCountry = cloudfrontViewerCountry && cloudfrontViewerCountry.toLowerCase() || "us";
        return /*#__PURE__*/ _jsxs("div", {
            id: id,
            className: `jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash} jsx-${phoneInputStyles.__hash}` + " " + "hp-input hp-phone-input",
            children: [
                /*#__PURE__*/ _jsx(PhoneInputComponent, {
                    country: defaultCountry,
                    value: value,
                    onChange: this.handleChange,
                    onFocus: this.handleFocus,
                    onBlur: this.handleBlur,
                    name: inputName,
                    enableSearch: true,
                    disableSearchIcon: true,
                    inputClass: showRequiredError ? "input-required" : "",
                    specialLabel: ""
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: phoneInputStyles.__hash,
                    children: phoneInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "handleFocus", ()=>{});
        _define_property(this, "handleBlur", ()=>{
            const { onInputBlur, value, inputData } = this.props;
            const { inputName } = inputData;
            if (onInputBlur) {
                onInputBlur({
                    target: {
                        name: inputName,
                        value
                    }
                });
            }
        });
        _define_property(this, "handleChange", (phone)=>{
            const { onInputChange, inputData } = this.props;
            const { inputName } = inputData;
            if (onInputChange) {
                onInputChange({
                    target: {
                        name: inputName,
                        value: phone
                    }
                });
            }
        });
    }
}
export default withGenericConfig(PhoneInput);
